export default __webpack_public_path__ + "static/media/gap.203aced9.svg";